export const genreOptions = ['动作', '剧情', '爱情', '惊悚', '犯罪', '悬疑', '文艺', '都市', '历史'] as const;

export const regionOptions = ['美国', '韩国', '日本', '法国', '英国', '中国香港', '西班牙'] as const;

export const yearOptions = [2026, 2025, 2024] as const;